"use strict";
import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import { environment } from "environments/environment";

@Injectable()
export class API {
	constructor() {}

	public static API_URL = environment.apiUrl;

	/**
	 * PLS API Service Call - Default Http Options Configuration
	 */
	public static defaultHTTPOptions = {
		headers: new HttpHeaders({
			"Content-Type": "application/json; charset=utf-8",
			"Authorization": "X-API-KEY " + process.env.WEBSVCAPIKEY
		})
	};

	/**
	 * PLS API Service Call - Media File Http Options Configuration
	 */
	public static mediaHTTPOptions = {
		headers: new HttpHeaders({
			Authorization: "X-API-KEY " + process.env.WEBSVCAPIKEY
		})
	};
}
